<template>
  <div class="page" :class="{ 'page__has-bar': !readonly }">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__hd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">单据编号</label>
            <em class="weui-form-preview__value">{{ form.main.pc_code }}</em>
          </div>
        </div>
        <custom-layout
          class="weui-form-preview__bd"
          :view-config="customViewConfig"
        >
          <div class="weui-form-preview__item" slot="pc_pjcode">
            <label class="weui-form-preview__label">{{
              customLabel.pc_pjcode || "立项单号"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.pc_pjcode
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="pj_dename">
            <label class="weui-form-preview__label">{{
              customLabel.pj_dename || "项目名称"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.pj_dename
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="pj_emname">
            <label class="weui-form-preview__label">{{
              customLabel.pj_emname || "项目负责人"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.pj_emname
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="pj_emtel">
            <label class="weui-form-preview__label">{{
              customLabel.pj_emtel || "联系电话"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.pj_emtel
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="pc_rpname">
            <label class="weui-form-preview__label">{{
              customLabel.pc_rpname || "研发阶段"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.pc_rpname
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="pc_opinion">
            <label class="weui-form-preview__label">{{
              customLabel.pc_opinion || "项目总结意见"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.pc_opinion
            }}</span>
          </div>
        </custom-layout>
      </div>

      <div class="form-preview weui-form-preview">
        <div
          class="weui-form-preview__bd form-detail-preview"
          v-for="item in form.items"
          :key="item.id"
        >
          <div class="form-detail-preview_num">{{ item.pcd_detno }}</div>
          <custom-layout :view-config="customViewConfig" position="detail1">
            <div class="weui-form-preview__item" slot="ta_code">
              <label class="weui-form-preview__label">{{
                customLabel.ta_code || "任务单号"
              }}</label>
              <span class="weui-form-preview__value">{{ item.plmProjTaskDTO.ta_code }}</span>
            </div>
            <div class="weui-form-preview__item" slot="ta_task">
              <label class="weui-form-preview__label">{{
                customLabel.ta_task || "任务名称"
              }}</label>
              <span class="weui-form-preview__value">{{ item.plmProjTaskDTO.ta_task }}</span>
            </div>
            <div class="weui-form-preview__item" slot="ta_taskstatus">
              <label class="weui-form-preview__label">{{
                customLabel.ta_taskstatus || "任务状态"
              }}</label>
              <span class="weui-form-preview__value">{{ item.plmProjTaskDTO.ta_taskstatus }}</span>
            </div>
            <div class="weui-form-preview__item" slot="rd_taskreq">
              <label class="weui-form-preview__label">{{
                customLabel.rd_taskreq || "任务要求"
              }}</label>
              <span class="weui-form-preview__value">{{ item.plmProjTaskDTO.rd_taskreq }}</span>
            </div>
            <div class="weui-form-preview__item" slot="ta_taskreq">
              <label class="weui-form-preview__label">{{
                customLabel.ta_taskreq || "已完成任务要求"
              }}</label>
              <span class="weui-form-preview__value">{{ item.plmProjTaskDTO.ta_taskreq }}</span>
            </div>
            <div class="weui-form-preview__item" slot="ta_emname">
              <label class="weui-form-preview__label">{{
                customLabel.ta_emname || "责任人"
              }}</label>
              <span class="weui-form-preview__value">{{
                item.plmProjTaskDTO.ta_emname
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="ta_planbegindate">
              <label class="weui-form-preview__label">{{
                customLabel.ta_planbegindate || "计划开始日期"
              }}</label>
              <span class="weui-form-preview__value"  v-format="'yyyy-MM-dd hh:mm'">{{
                item.plmProjTaskDTO.ta_planbegindate
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="ta_planenddate">
              <label class="weui-form-preview__label">{{
                customLabel.ta_planenddate || "计划完成日期"
              }}</label>
              <span class="weui-form-preview__value"  v-format="'yyyy-MM-dd hh:mm'">{{
                item.plmProjTaskDTO.ta_planenddate
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="ta_actbegindate">
              <label class="weui-form-preview__label">{{
                customLabel.ta_actbegindate || "实际开始日期"
              }}</label>
              <span class="weui-form-preview__value"  v-format="'yyyy-MM-dd hh:mm'">{{
                item.plmProjTaskDTO.ta_actbegindate
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="ta_actenddate">
              <label class="weui-form-preview__label">{{
                customLabel.ta_actenddate || "实际完成日期"
              }}</label>
              <span class="weui-form-preview__value"  v-format="'yyyy-MM-dd hh:mm'">{{
                item.plmProjTaskDTO.ta_actenddate
              }}</span>
            </div>
          </custom-layout>
        </div>
      </div>

      <file-list v-model="form.main.pc_attach" />
    </div>

    <div class="footer-bar weui-dialog__ft" v-if="!readonly">
      <router-link
        :to="'/plm/proj_check_edit?id=' + form.main.id"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_primary"
        >编辑</router-link
      >
      <a
        href="javascript:;"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_primary"
        @click="f_audit"
        >审核</a
      >
      <a
        href="javascript:;"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="p_remove"
        >删除</a
      >
      <a
        href="javascript:;"
        v-if="!editable"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="f_unaudit"
        >反审</a
      >
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import FileList from "@/components/FileList.vue";
import process from "@/mixins/process.js";
// import CustomField from "@/components/field/CustomField.vue";

export default {
  mixins: [process],
  components: {
    CustomLayout,
    FileList,
    // CustomField,
  },
  data() {
    return {
      baseUrl: "/api/plm/projcheck",
      codeField: "pc_code",
      statusField: "pc_statuscode",
      caller: "PlmProjCheck",
      xtype: "plm-projcheck-formpanel",
    };
  },
};
</script>